@if (subProjectIdList.length === 1) {
  <app-customer-group-tool-bar [customStyle]="customStyle"></app-customer-group-tool-bar>
}
@if (subProjectIdList.length > 1) {
  <div>
    <mat-form-field class="full-width" style="padding: 7px 10px 0 10px;height: 80px;border-radius: 0 0 5px 5px;" appearance="outline">
      <mat-label>Projetos</mat-label>
      <mat-select placeholder="Projetos"  [formControl]="subProjectFilterControl">
        @for (subProjectId of subProjectIdList; track subProjectId) {
          <mat-option [value]="subProjectId">
            {{ findSubProjectById(subProjectId)?.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
<div class="flex-row-wrap">
  @for (remoteAppWrapper of remoteAppHtml5List; track remoteAppWrapper) {
    @if (remoteAppWrapper.remoteAppId && remoteAppWrapper.status !== 'DELETING' && (!subProjectFilterControl.value || subProjectFilterControl.value == remoteAppWrapper.subProjectId)) {
      <div
        [title]="remoteAppWrapper?.remoteAppId"
        matTooltip="Clique para abrir o aplicativo"
        [matTooltipDisabled]="remoteAppWrapper.status === 'READY' || remoteAppWrapper.status === 'CLIENT_NOT_CONNECTED'"
        appDebounceClick
        (click)="onOpen(remoteAppWrapper)"
        [class.remote-app-error]="remoteAppWrapper.status === 'SERVER_NOT_CONNECTED'"
        [class.remote-app-ok]="remoteAppWrapper.status === 'READY' || remoteAppWrapper.status === 'CLIENT_NOT_CONNECTED'"
        class="m-14 remote-app flex-col align-center-center">
        <img alt="{{remoteAppWrapper.remoteAppId}}" [class.remote-app-image-error]="remoteAppWrapper.status === 'SERVER_NOT_CONNECTED'"
          [class.remote-app-image-warn]="remoteAppWrapper.status === 'CLIENT_NOT_CONNECTED'  || remoteAppWrapper.status === 'PREPARING'"
          [src]=imageFileService.getRemoteAppPictureUrl(remoteAppWrapper.imageUUID)
          width="64" height="64" loading="lazy">
        <div class="remote-app-name mt-8">{{remoteAppWrapper.appName}}</div>
      </div>
    }
  }
  @if (getVisibleApps().length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-state-icon">apps</mat-icon>
      <div class="empty-state-text">Nenhum aplicativo disponível</div>
    </div>
  }
</div>